module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-questions d-flex"
  }, [_c('img', {
    staticClass: "detail-questions-image",
    attrs: {
      "src": _vm.validationImage,
      "alt": _vm.validationName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-question"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "question-name"
  }, [_vm._v(_vm._s(_vm.validationName))]), _vm._v(" "), (_vm.validationNationality) ? _c('img', {
    staticClass: "question-nationality",
    attrs: {
      "src": _vm.question.nationality,
      "alt": _vm.question.nationality
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "question"
  }, [_vm._v(_vm._s(_vm.question.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07c4e32e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/questions.vue
// module id = 1067
// module chunks = 1